import {EventVO, EventListVO} from './event.interfaces';
import {All} from './event.actions';
import {CrudAll, crudInitialState, CrudReducer, CrudState, createCrudDefinition} from '@abydos-angular/store';

export interface EventState extends CrudState<EventVO> {
}

export const initialState: EventState = {
    ...crudInitialState
};

export const eventFeatureName = 'event';

export const eventDefinition = createCrudDefinition<EventVO, EventListVO>(eventFeatureName , initialState);
/*
Ez egy minta sub definíció, ha a modulban 1-nél több CRUD-ra van szükség
export const eventSubDefinition = createCrudDefinition<EventSubVO, EventSubListVO>(eventDefinition, crudInitialState, 'eventSub');
 */

export function eventReducer<T, S>(state: EventState, action: All): EventState {
    switch (action.type) {
        default: {
            return CrudReducer(eventDefinition, state, action as CrudAll<T, S>) as EventState;
        }
    }
}
